var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsNotEmpty, IsOptional } from 'class-validator';
import { UserExposeGroup } from '../interface/user-expose-group';
export class ReadUserSubscriptionDto {
}
__decorate([
    ApiProperty({ type: () => Boolean }),
    IsNotEmpty({ always: true }),
    IsBoolean({ always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ, UserExposeGroup.CREATE, UserExposeGroup.PATCH, UserExposeGroup.UPDATE] }),
    IsOptional({ groups: [UserExposeGroup.CREATE, UserExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadUserSubscriptionDto.prototype, "isMarketingEnabled", void 0);
__decorate([
    ApiProperty({ type: () => Boolean }),
    IsNotEmpty({ always: true }),
    IsBoolean({ always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ, UserExposeGroup.CREATE, UserExposeGroup.PATCH, UserExposeGroup.UPDATE] }),
    IsOptional({ groups: [UserExposeGroup.CREATE, UserExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadUserSubscriptionDto.prototype, "isMarketingEmailEnabled", void 0);
__decorate([
    ApiProperty({ type: () => Boolean }),
    IsNotEmpty({ always: true }),
    IsBoolean({ always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ, UserExposeGroup.CREATE, UserExposeGroup.PATCH, UserExposeGroup.UPDATE] }),
    IsOptional({ groups: [UserExposeGroup.CREATE, UserExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadUserSubscriptionDto.prototype, "isMarketingSMSEnabled", void 0);
__decorate([
    ApiProperty({ type: () => Boolean }),
    IsNotEmpty({ always: true }),
    IsBoolean({ always: true }),
    Expose({ groups: [UserExposeGroup.MODEL, UserExposeGroup.READ, UserExposeGroup.CREATE, UserExposeGroup.PATCH, UserExposeGroup.UPDATE] }),
    IsOptional({ groups: [UserExposeGroup.CREATE, UserExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadUserSubscriptionDto.prototype, "isMarketingPushNotificationsEnabled", void 0);
//# sourceMappingURL=ReadUserSubscriptionDto.js.map